module.exports = __webpack_public_path__ + "img/BL.98060b13.png";